/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type LicenseRequestType = {
  token: string;
};

export type LicenseInfo = {
  customer_id: string;
  customer_name: string;
  license_status: string;
  license_type: string;
  timezone: string;
  expires_at: string;
  max_concurrent_requests: number;
  max_service_tokens: number;
  current_service_tokens: number;
  current_policy_num: number;
  data_retention_days: number;
  data_retention_record_limit: number;
  mode: string;
};

export type LicenseType = {
  license_info: LicenseInfo;
};

export default function getLicense({ token }: LicenseRequestType): Promise<InternalResponse> {
  return request()({
    url: "/xecguard/v1/licenses",
    method: "GET",
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<LicenseType>): InternalResponse<LicenseType> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
